import * as React from "react";
import { TagLinksTable } from "../../components/detail/tagLinksTable";
import { tagLinkUrlPrefixes } from "../../services/utils";
import { Location } from "../../schema/types/location/entity";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { FormItemDescription } from "../../components/antd/form/FormItemDescription";
import { FormItem } from "../../components/antd/form/FormItem";
import { FormLabel } from "../../components/antd/form/FormLabel";
import { FormItemValue } from "../../components/antd/form/FormItemValue";
import { CopyButtonWithApproval } from "../domain/create/copyButtonWithApproval";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpTextArea } from "../gvc/testNewForm/CpTextArea";
import { CpLabelDirtyIndicator } from "../gvc/testNewForm/CpLabelDirtyIndicator";
import { CpTooltip } from "../gvc/testNewForm/CpTooltip";

interface Props {
  location: Location;
}
export const Summary: React.FC<Props> = ({ location }) => {
  const hasTagLinks =
    Object.entries(location.tags || {}).filter(([_, value]) =>
      tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)),
    ).length > 0;

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`description`}>
                <FormLabel>Description</FormLabel>
                <CpLabelDirtyIndicator name={`description`} />
              </CpLabel>
              <CpTextArea autoSize name={`description`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`description`} />
            </CpFormItem>
            <div className="flex flex-wrap gap-x-32 gap-y-8 mt-4 mb-8">
              <FormItem lastItem>
                <FormLabel>Provider</FormLabel>
                <FormItemValue>{location.provider}</FormItemValue>
              </FormItem>
              <FormItem lastItem>
                <FormLabel>Region</FormLabel>
                <FormItemValue>{location.region || "-"}</FormItemValue>
              </FormItem>
              <FormItem lastItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Enabled</FormLabel>
                  <CpTooltip
                    tooltipProps={{ title: `If a location is not enabled, it won't be available to select for GVCs.` }}
                  />
                </div>
                <FormItemValue className={`${location.spec?.enabled ? "color-action" : "color-danger"}`}>
                  {location.spec?.enabled ? "Yes" : "No"}
                </FormItemValue>
              </FormItem>
            </div>
            <FormItem>
              <FormLabel>IP Ranges</FormLabel>
              {(location.status?.ipRanges || []).length < 1 ? (
                <FormItemValue>No value is reported</FormItemValue>
              ) : (
                <div className="flex flex-col gap-1">
                  {location.status!.ipRanges!.map((ip) => (
                    <FormItemValue>
                      <span>{ip}</span>
                      <CopyButtonWithApproval className="ml-1" value={ip} />
                    </FormItemValue>
                  ))}
                </div>
              )}
            </FormItem>
            {hasTagLinks ? (
              <TagLinksTable
                tableId="location-info-tag-links"
                tags={Object.entries(location.tags || {})
                  .filter(([_, value]) => tagLinkUrlPrefixes.some((p) => String(value).startsWith(p)))
                  .map(([key, value]) => ({ key, value }))}
                styles={{ container: { width: "100%" }, header: { marginBottom: 0 } }}
              />
            ) : null}
          </CardContent>
        </Card>
      </div>
    </>
  );
};
